<template>
  <div class="filter-bar">
    <template v-if="showSearch && searchPlaceholder">
      <v-text-field
        class="filter-bar__search"
        :placeholder="searchPlaceholder"
        :value="localSearch"
        dense
        outlined
        hide-details
        clearable
        @input="localSearch = $event"
      />
    </template>
    <template v-for="filter in filters">
      <BaseDateStepper
        v-if="['date', 'date_range'].includes(filter.type)"
        :key="filterIdentifier(filter)"
        class="filter-bar__date"
        :data-field="sanitizeDataField(filter.param)"
        :label="filter.label"
        :value="values[filter.param] || ''"
        :max="filter.max"
        :min="filter.min"
        :range="filter.type === 'date_range'"
        :presets="filter.presets"
        @on-input-date-picker="onFilterChange(filterIdentifier(filter), $event)"
      />
      <v-select
        v-else
        :key="filterIdentifier(filter)"
        class="filter-bar__select"
        :data-field="sanitizeDataField(filter.param)"
        :items="filter.options"
        item-text="label"
        item-value="value"
        :label="filter.label"
        :value="values[filter.param]"
        dense
        outlined
        hide-details
        @change="onFilterChange(filterIdentifier(filter), $event)"
      />
    </template>
    <BaseButton
      v-if="showSearch && ((filters && filters.length) || searchPlaceholder)"
      class="filter-bar__submit"
      @click="onSubmit"
    >
      Filtrar
    </BaseButton>
    <div
      v-if="$slots.actions"
      class="filter-bar__actions"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import BaseDateStepper from './BaseDateStepper.vue'
import { sanitizeDataField } from './dataFieldUtils'

export default {
  name: 'BaseFilterBar',
  components: { BaseDateStepper },
  props: {
    searchPlaceholder: {
      type: String,
      required: false,
      default: ''
    },
    search: {
      type: String,
      required: false,
      default: ''
    },
    filters: {
      type: Array,
      required: false,
      default: () => []
    },
    values: {
      type: Object,
      required: false,
      default: () => ({})
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      localSearch: this.search
    }
  },
  watch: {
    search(value) {
      this.localSearch = value
    }
  },
  methods: {
    filterIdentifier(filter) {
      return filter.param || filter.key
    },
    onFilterChange(key, value) {
      this.$emit('filter-change', key, value)
    },
    onSubmit() {
      this.$emit('submit', this.localSearch)
    },
    sanitizeDataField
  }
}
</script>

<style lang="scss">
.filter-bar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;

  &__search {
    flex: 1;
    min-width: 200px;
  }

  &__select {
    max-width: 220px;
  }

  &__date {
    flex: none;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
}
</style>
